// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 897 ? "sentry" : chunkId) + ".legacy." + {"359":"9a1a1f8c9bc345258436","897":"069d3609abbce8096c0a"}[chunkId] + ".js";
};